// components/DictionariesSection.jsx
import React from "react";
import SectionHeading from "./SectionHeading";
import Reveal from "./Reveal";
import styles from "../Info.module.css";

const dictionaries = [
  "Google Translate",
  "Bing",
  "DeepL",
  "Cambridge",
  "Collins",
  "B-amooz",
  "Abadis",
  "FastDic",
  "Glosbe",
];

const DictionariesSection = () => {
  return (
    <section className={styles.section}>
      <div className={styles.sectionInner}>
        <Reveal>
          <SectionHeading
            badge="دیکشنری‌ها"
            badgeColor="purple"
            title="دیکشنری‌های پشتیبانی‌شده"
            subtitle="از هر لغتی هر دیکشنری که خواستی باز کن — همه‌شون کنار هم."
          />
        </Reveal>

        <Reveal delay={100}>
          <div className={styles.dictChips}>
            {dictionaries.map((dict) => (
              <span key={dict} className={styles.dictChip}>
                <i className="fas fa-book-open"></i>
                {dict}
              </span>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default DictionariesSection;